import React from 'react';
import { ChevronDown, User } from 'lucide-react';

const StudentSelector = ({ students, selectedStudent, onStudentChange, mobile = false }) => {
  if (!students || students.length === 0) {
    return (
      <div className="text-sm text-slate-500">
        No students found
      </div>
    );
  }

  if (students.length === 1) {
    const student = students[0];
    return (
      <div className={`flex items-center gap-3 ${mobile ? 'p-3 bg-white rounded-lg border' : ''}`}>
        <div className="w-8 h-8 bg-gradient-to-br from-azure-100 to-azure-200 rounded-full flex items-center justify-center">
          <User className="w-4 h-4 text-azure-700" />
        </div>
        <div>
          <div className="font-medium text-slate-900">
            {student.name || student.displayName || 'Student'}
          </div>
          {!mobile && (
            <div className="text-xs text-slate-500">
              College Journey
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className={`relative ${mobile ? 'w-full' : ''}`}>
      <select
        value={selectedStudent?.id || ''}
        onChange={(e) => {
          const student = students.find(s => s.id === e.target.value);
          if (student) {
            onStudentChange(student);
          }
        }}
        className={`
          appearance-none bg-white border-2 border-slate-200 rounded-lg px-4 py-3
          focus:border-azure-500 focus:outline-none transition-colors
          ${mobile ? 'w-full' : 'min-w-[200px]'}
        `}
      >
        <option value="">Select a student...</option>
        {students.map((student) => (
          <option key={student.id} value={student.id}>
            {student.name || student.displayName || 'Student'}
          </option>
        ))}
      </select>

      <ChevronDown
        className="absolute right-3 top-1/2 transform -translate-y-1/2 text-slate-400 pointer-events-none"
        size={16}
      />

      {selectedStudent && !mobile && (
        <div className="absolute -bottom-6 left-0 text-xs text-slate-500">
          Supporting {selectedStudent.name || selectedStudent.displayName}'s journey
        </div>
      )}
    </div>
  );
};

export default StudentSelector;